<app-dialog
    class="dialog"
    [header]="'Waste / Destroy Inventory'"
    subHeader="Wasting / Destroying inventory requires a witness by law"
    subheaderIconName="icon-warning-red"
    [show]="true"
    [hasControls]="true"
    [saveBtnText]="'Waste / Destroy' + ' ' + orderNdcs?.length + ' Drug' + (orderNdcs?.length > 1 ? 's' : '')"
    [saveBtnMinWidth]="190"
    [hideControlsDivider]="true"
    (save)="submitForm()"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="nameOfDestruction.focusInput()"
    (onSubmitKeyDown)="nameOfDestruction.focusInput()"
    [id]="dialogId"
    [scrollable]="true"
    maxHeight="98vh"
    #dialog
>
    <div [class.hidden]="!orderNdcs?.length">
        <div [formGroup]="form" class="controls-container">
            <app-input label="Name"
                formControlName="nameOfDestruction"
                placeholder="Spring 2024 Destruction"
                [symbolsLeftCounter]="true"
                [maxLength]="40"
                #nameOfDestruction
            ></app-input>
            <app-input label="Method" class="destruction-method"
                formControlName="methodOfDestruction"
                placeholder="Drugs were dropped at a drug take back location"
            ></app-input>
            <app-autocomplete class="autocomplete"
                [data]="autocompleteData" searchKeyword="name"
                [control]="form.controls.placeOfDestructionId"
                label="Place"
                placeholder="Pharmacy"
                (itemAdded)="itemAdded.emit($event)"
                #autocomplete
            >
            </app-autocomplete>
        
            <app-datepicker-input [tabInd]="0"
                class="ml-[8px]"
                label="Date/Time"
                pickerType="both"
                formControlName="transactionDateDisplayValue"
                (dateTimeChange)="dateTimeChanged($event)"
                (inputTabKeyDown)="focusFirstInput()"
                [dateMax]="now()"
                calendarPosition="right"
                #transactionDatePicker>
            </app-datepicker-input>
        </div>
        <app-supplier-buyer-card class="block pb-8"
            [data]="supplier"
            (addedModified)="supplierAddedModified($event)">
        </app-supplier-buyer-card>
        <div class="-ml-8 -mr-8">
            <div #fileAttachment>
                <app-file-attachment 
                    [files]="files"
                    [fileTypes]="fileTypes"
                    [requiresSignature]="true"
                    [loadFileBeforeReSigning]="false"
                    headerClasses="text-sm"
                    [tableHeight]="89"
                    (saveFiles)="saveFiles($event)"
                >
                </app-file-attachment>
            </div>
            <app-generic-write-table *ngIf="orderNdcs.length"
                [ngStyle]="{'--table-height': 'calc(100vh-200px)'}"
                [formArray]="orderNdcs" [columns]="columns"
                [useDefaultLocationChangeHandler]="true"
                [enabledBackCountNdcIDs]="enabledBackCountNdcIDs"
                adNdcClasses="ml-8"
                [isScrollable]="false"
                (addNdc)="addNdcMode = true"
                (rowDeleted)="handleRowDeletedSideEffect($event)"
                (onLastNumberInputKeyupEnter)="handleLastInputTabbing()"
                (onLastInputKeydownTab)="handleLastInputTabbing()"
                #table
            >
            </app-generic-write-table>
        </div>
    </div>
</app-dialog>

<app-dialog *ngIf="addNdcMode || !orderNdcs.length"
    [show]="true"
    [header]="'Add new NDC'"
    subHeader="Wasting / Destroying inventory requires a witness by law"
    subheaderIconName="icon-warning-red"
    [hasControls]="true"
    (cancel)="cancelAddNewNdc()"
    [hideSaveButton]="true"
    [hideControlsDivider]="true"
    [minWidth]="780"
    >
    <app-input-search-scanner 
        class="scanner"
        [autofocus]="true"
        [isInventory]="true"
        (optionSelected)="optionSelected($event)"
        [placeholder]="'Scan barcode (Or search drug name or NDC)'"
        [label]="'Which drug do you want to add?'"
        [active]="true"
        [singleLocationResult]="true"
        [locationsToExclude]="getLocationsToExclude()"
        [searchEmptyInventory]="false"
        #searchScanner
    ></app-input-search-scanner>
</app-dialog>